<template>
  <div>

    <HeroBanner
      heading="Get the best price for your property, fast"
      subheading="The PFX platform gives sellers the power to competitively auction their properties to qualified buyers quickly and easily."
      theme="sellers"
      :image="require('../assets/sellers-hero.jpg')"
      :buttons="[]"
    />

    <div class="split-view clearfix">
      <div class="column text-padding">
        <h2>Sell with certainty</h2>
        <ul class="icons">
          <li><v-icon color="brand">check</v-icon> Create custom auctions</li>
          <li><v-icon color="brand">check</v-icon> Control auction terms and close</li>
          <li><v-icon color="brand">check</v-icon> Consolidate all required documentation </li>
          <li><v-icon color="brand">check</v-icon> Qualify buyers before they bid</li>
          <li><v-icon color="brand">check</v-icon> Close your properties on time, every time.</li>
        </ul>
      </div>
      <div class="column image-padding easy-image">
        &nbsp;
      </div>
    </div>

    <div class="container why-pfx">
      <h2 class="align-center">Why PFX</h2>
      <div class="clearfix columns">
        <div class="three-column">
          <div><img :src="require('../assets/why-close.svg')"/></div>
          <h3>Eliminate counter offers and renegotiation </h3>
          <p>Stop the uncertainty of negotiating in escrow and “Back on Market” (BOM). With due diligence completed up front, the highest bid wins the property.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-buyer.svg')"/></div>
          <h3>Get Qualified Buyers</h3>
          <p>Pre-qualify bidders before the auction starts. Buyers upload the documents you specify for your review and approval.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-price.svg')"/></div>
          <h3>Achieve the Highest Price</h3>
          <p>You set your minimum price and let buyers outbid each other until the auction closes. When buyers compete transparently, everyone wins.</p>
        </div>
      </div>
      <div class="clearfix columns">
        <div class="three-column">
          <div><img :src="require('../assets/why-time.svg')"/></div>
          <h3>Close On Time</h3>
          <p>You set the time frame for buyer qualification and the Live auction. Proceed to close of escrow within your preset timeline.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-add.svg')"/></div>
          <h3>Get your agent in on the action</h3>
          <p>Tell your agent you want to use PFX to sell your property.</p>
        </div>
      </div>
    </div>

    <div class="split-view clearfix">
      <div class="split-view-1">
        <div class="column text-padding">
          <h2>Create auctions on your terms</h2>
          <p>
            Set the auction registration period, the auction open and close dates and the starting price.
            Upload due diligence documents and specify required items for bidders.
          </p>
        </div>
        <div class="column create-auctions-image">
          <div class="image-padding image-overlay">
            <img :src="require('../assets/screenshot-auction-box.png')" />
          </div>
        </div>
      </div>

      <div class="split-view-2">
        <div class="column approve-bidder-image">
          <div class="image-padding image-overlay">
            <img :src="require('../assets/screenshot-approve-bidders.png')" />
          </div>
        </div>
        <div class="column text-padding">
          <h2>Approve qualified bidders</h2>
          <p>
            Get notified when buyers register for your auctions. Review their registration form and required documents.
            Once you approve the buyers, they can participate in a fair and secure auction process.
          </p>
        </div>
      </div>

      <div class="split-view-3">
        <div class="column text-padding">
          <h2>Monitor your auctions, anytime, from anywhere</h2>
          <p>
            Login to your dashboard to get a real-time overview on all auction activities,
            from bid details to auction status and more.
          </p>
        </div>
        <div class="column monitor-dashboard-image">
          <div class="image-padding image-overlay">
            <img :src="require('../assets/screenshot-monitor-seller.png')" />
          </div>
        </div>
      </div>
    </div>

    <div class="call-to-action-1 align-center">
      <h2>Ready to sell your property with PFX?</h2>
      <!--<button class="btn-rounded fat" @click="$store.commit('openSignUpDialog')">Get Started</button>-->
    </div>

    <div class="videos clearfix" v-if="hideVideos">
      <div class="column video1">
        <h2>Watch PFX Videos to learn more</h2>
      </div>
      <div class="column video2 pointer" @click="$store.commit('openYouTubeDialog', 'E5yFcdPAGv0')"><!-- TODO change video -->
        <div class="title">Get Started <div class="length">5:40</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video3 pointer" @click="$store.commit('openYouTubeDialog', 'HyHNuVaZJ-k')"><!-- TODO change video -->
        <div class="title">Create Listing <div class="length">8:00</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video4 pointer" @click="$store.commit('openYouTubeDialog', 'GgwE94KZJ7E')"><!-- TODO change video -->
        <div class="title">Approve Bidding <div class="length">4:32</div></div>
        <div class="play"></div>
      </div>
    </div>

    <div class="container faq-section">
      <h2>Get answers to commonly asked questions</h2>
      <FaqSellers :embed="true" />
    </div>

  </div>
</template>

<script>
  import HeroBanner from './elements/HeroBanner.vue'
  import FaqSellers from './FaqSellers.vue'

  export default {
    name: 'AboutSellers',
    components: {
      HeroBanner,
      FaqSellers
    },
    data() {
      return {
        hideVideos: process.env.config.frontend.hideVideos
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .easy-image {
    background-image: url('../assets/sellers-pen.jpg');
    background-size: cover;
    background-position: center;
    height: 471px;
  }

  h2 {
    font-family: 'Encode Sans', sans-serif;
    font-size: 24px;
    font-weight: 600;
  }

  .why-pfx {
    padding: 100px 50px;

    h2 {
      margin-bottom: 59px;
    }
    .columns {
      padding: 0 0 2em;
      text-align: center;
      img {
        height: 60px;
      }
    }
    h3 {
      font-family: 'Encode Sans', sans-serif;
      font-weight: 600;
      font-size: 16px;
    }
    p {
      font-size: 16px;
    }
  }

  .split-view-2 {
    .text-padding {
      background-color: #1B292E;
      color: #fff;
      height: 676px;
      padding: 120px 60px 40px;
    }
    .image-padding {
      height: 676px;
    }
    h2 {
      margin-bottom: 30px;
    }
  }

  .create-auctions-image,
  .approve-bidder-image,
  .monitor-dashboard-image {
    background-size: cover;
    background-position: center;
    height: 676px;
  }
  .create-auctions-image {
    background-image: url('../assets/brokers-building.jpg');
  }
  .approve-bidder-image {
    background-image: url('../assets/brokers-cameraman.jpg');
  }
  .monitor-dashboard-image {
    background-image: url('../assets/brokers-reflection.jpg');
  }
  .image-overlay {
    background-color: rgba(#000, .5);
    width: 100%;
    height: 100%;
    text-align: center;
    img {
      padding: 55px;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .call-to-action-1 {
    margin: 0 auto;
    padding: 41px 0 55px;
    background-color: #1B292E;
    background-image: url('../assets/signup-banner.svg');
    background-size: cover;
    background-position: bottom left;
    color: #fff;
    text-shadow: 2px 2px 2px #000;
  }

  .faq-section {
    padding: 100px 40px 120px;
    h2 {
      margin-bottom: 50px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AboutSellers.vue